import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";

import { datadogRum } from '@datadog/browser-rum';

import App from "./App";
import { DeploymentEnvironmentConstants } from "./shared/constants";

import { CookiesProvider } from "react-cookie";
import { Helmet } from "react-helmet";
import { FeatureFlagContextProvider } from "./feature-flags/FeatureFlagContext";

// Enable Sentry for non-development environments.
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://34092f8ac62c43f88e47f2b7eb9c8876@sentry.io/1369074", // There is only ever one value for this, it doesn't vary by environment.

    // Purposely filter out __ENVIRONMENT__ and __RELEASE_ENVIRONMENT__ to keep things clean if someone forgets to set a configuration value.
    environment: window.environment && !(["__ENVIRONMENT__", "__RELEASE_ENVIRONMENT__"].find((s) => s === window.environment))
      ? window.environment
      : DeploymentEnvironmentConstants.Local,

    release: window.sourceVersion || undefined,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <CookiesProvider>
    <Helmet>
      <title>Quest Analytics&reg;</title>
    </Helmet>
    <FeatureFlagContextProvider>
      <App />
    </FeatureFlagContextProvider>
  </CookiesProvider>,
);

if (process.env.NODE_ENV !== "development") {
  datadogRum.init({
    applicationId: window.datadogAppId,
    clientToken: window.datadogClientToken,
    env: window.environment,
    sampleRate: 100,
    site: "datadoghq.com",
    trackInteractions: true,
    trackViewsManually: true,
    version: window.buildVersion,
  });
}

if (module.hot) {
  module.hot.accept("./App", () => { root.render(<App />); });
}